import { Api } from './Api';

export default {
    /*  1. Get all data by Criteria*/
    GetPageByCriteria(body = { keyword: '' }) {
        return Api().post('/Page/GetPageByCriteria', body);
    },

    /*  1. Get all data by keyword */
    getPages(keyword = '') {
        var body = { keyword: keyword }
        return Api().post('/Page/GetPageByCriteria', body);
    },

/*  1. Get all data */
    //getPages(keyword = '') {
    //    return Api().get(`/Page${keyword ? '?Keyword=' + keyword : ''}`);
    //},

/*  2. Get one column */
    getPage(id) {
        return Api().get(`/Page/${id}`);
    },

/*  3. Create one column */
    savePage(body) {
        return Api().post(`/Page`, body);
    },

    /*  4. Delete one or more columns */
    deletePages(pages) {
        return Api().post(`/Page/DeletePage`, pages);
    },


/*  5. post one or more columns */
    postPages(pages) {
        return Api().post(`/Page/PostPage`, pages);
    },
}